import { NavMain } from "./NavMain";
import { NavProjects } from "./NavProjects";
import { NavSecondary } from "./NavSecondary";
import { NavUser } from "./NavUser";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import {
  BarChart,
  Bell,
  BookOpen,
  Bot,
  Building2,
  Command,
  CreditCard,
  FileSpreadsheet,
  FileText,
  Frame,
  HelpCircle,
  LayoutDashboard,
  LifeBuoy,
  Map,
  MessageSquare,
  PieChart,
  Send,
  Settings2,
  Shield,
  SquareTerminal,
  User,
  FileSignature,
} from "lucide-react";
import { ComponentProps } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const AppSidebar = ({ ...props }: ComponentProps<typeof Sidebar>) => {
  const { t } = useTranslation();

  const data = {
    navMain: [
      // {
      //   title: "Головна",
      //   url: "/home",
      //   icon: SquareTerminal,
      //   isActive: true,
      // },
      {
        title: t("navigation.users", "Users"),
        url: "/home/users",
        icon: User,
      },
      {
        title: t("navigation.properties"),
        url: "/home/properties",
        icon: Building2,
      },
      {
        title: t("navigation.leases", "Leases"),
        url: "/home/leases",
        icon: FileSignature,
      },
      {
        title: t("navigation.systemSettings", "System Settings"),
        url: "/home/system-settings",
        icon: Settings2,
      },
      // {
      //   title: "Документи",
      //   url: "/home/documents",
      //   icon: FileText,
      //   items: [
      //     {
      //       title: "Всі документи",
      //       url: "/home/documents",
      //     },
      //     {
      //       title: "Створити",
      //       url: "/home/documents/new",
      //     },
      //     {
      //       title: "Архів",
      //       url: "/home/documents/archive",
      //     },
      //   ],
      // },
      // {
      //   title: "Платежі",
      //   url: "/home/payments",
      //   icon: CreditCard,
      // },
      // {
      //   title: "Заявки",
      //   url: "/home/requests",
      //   icon: Bot,
      // },
      // {
      //   title: "Чат",
      //   url: "/home/chat",
      //   icon: MessageSquare,
      // },
      // {
      //   title: "Сповіщення",
      //   url: "/home/notifications",
      //   icon: Bell,
      // },
      // {
      //   title: "Звіти",
      //   url: "/home/reports",
      //   icon: BarChart,
      // },
      // {
      //   title: "Безпека",
      //   url: "/home/security",
      //   icon: Shield,
      // },
      // {
      //   title: "CMS",
      //   url: "/home/cms",
      //   icon: LayoutDashboard,
      // },
      // {
      //   title: "Налаштування",
      //   url: "/home/settings",
      //   icon: Settings2,
      //   items: [
      //     {
      //       title: "Загальні",
      //       url: "/home/settings",
      //     },
      //     {
      //       title: "Профіль",
      //       url: "/home/settings/profile",
      //     },
      //     {
      //       title: "Безпека",
      //       url: "/home/settings/security",
      //     },
      //   ],
      // },
    ],
    navSecondary: [
      {
        title: t("navigation.support"),
        url: "/home/support",
        icon: HelpCircle,
      },
      {
        title: t("navigation.feedback"),
        url: "/home/feedback",
        icon: Send,
      },
    ],
    // projects: [
    //   {
    //     name: "Житловий комплекс",
    //     url: "/home/properties/complex",
    //     icon: Frame,
    //   },
    //   {
    //     name: "Комерційна нерухомість",
    //     url: "/home/properties/commercial",
    //     icon: PieChart,
    //   },
    //   {
    //     name: "Приватні будинки",
    //     url: "/home/properties/houses",
    //     icon: Map,
    //   },
    // ],
  };

  return (
    <Sidebar
      className="top-[--header-height] !h-[calc(100svh-var(--header-height))]"
      {...props}
    >
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <Link to="/home">
                <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
                  <Command className="size-4" />
                </div>
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-semibold">PropManage</span>
                  <span className="truncate text-xs">
                    Property Management
                  </span>
                </div>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
        <NavSecondary items={data.navSecondary} className="mt-auto" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  );
};
